// extracted by mini-css-extract-plugin
export default {"footer":"banner4_page_footer__euw0f"};